import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
/* Layout */
import Layout from '../views/layout/Layout'
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  // {path: '/Information', component: () => import(' @/views/Information/leaveMessage/index'), hidden: true},
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
]
//商城管理
export const asyncRouterMap = [
  //商品列表
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商品', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),//懒加载  ES常用的import方法
      meta: { title: '商品列表', icon: 'product-list' }
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/pms/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'productCate',
      name: 'productCate',
      component: () => import('@/views/pms/productCate/index'),
      meta: { title: '商品分类', icon: 'product-cate' }
    },
    {
      path: 'addProductCate',
      name: 'addProductCate',
      component: () => import('@/views/pms/productCate/add'),
      meta: { title: '添加商品分类' },
      hidden: true
    },
    {
      path: 'updateProductCate',
      name: 'updateProductCate',
      component: () => import('@/views/pms/productCate/update'),
      meta: { title: '修改商品分类' },
      hidden: true
    },
    {
      path: 'productAttr',
      name: 'productAttr',
      component: () => import('@/views/pms/productAttr/index'),
      meta: { title: '商品类型', icon: 'product-attr' }
    },
    {
      path: 'productAttrList',
      name: 'productAttrList',
      component: () => import('@/views/pms/productAttr/productAttrList'),
      meta: { title: '商品属性列表' },
      hidden: true
    },
    {
      path: 'addProductAttr',
      name: 'addProductAttr',
      component: () => import('@/views/pms/productAttr/addProductAttr'),
      meta: { title: '添加商品属性' },
      hidden: true
    },
    {
      path: 'updateProductAttr',
      name: 'updateProductAttr',
      component: () => import('@/views/pms/productAttr/updateProductAttr'),
      meta: { title: '修改商品属性' },
      hidden: true
    },
    {
      path: 'brand',
      name: 'brand',
      component: () => import('@/views/pms/brand/index'),
      meta: { title: '品牌管理', icon: 'product-brand' }
    },
    {
      path: 'addBrand',
      name: 'addBrand',
      component: () => import('@/views/pms/brand/add'),
      meta: { title: '添加品牌' },
      hidden: true
    },
    {
      path: 'updateBrand',
      name: 'updateBrand',
      component: () => import('@/views/pms/brand/update'),
      meta: { title: '编辑品牌' },
      hidden: true
    },
    //分类管理
    {
      path: 'classification',
      name: 'classification',
      component: () => import('@/views/pms/classification/index'),
      meta: { title: '分类管理' },
      hidden: true
    },
    //物流管理
    {
      path: 'logistics',
      name: 'logistics',
      component: () => import('@/views/pms/logistics/index'),
      meta: { title: '物流管理' },
      hidden: true
    },
    //退货地址
    {
      path: 'address',
      name: 'address',
      component: () => import('@/views/pms/address/index'),
      meta: { title: '退货地址' },
      hidden: true
    }
    ]
  },
  //订单管理
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'order' },
    children: [
      {
        path: 'order/index',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: '订单列表', icon: 'product-list' }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: { title: '发货列表' },
        hidden: true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: { title: '订单设置', icon: 'order-setting' }
      },
      //售后订单
      {
        path: 'salesOrder',
        name: 'salesOrder',
        component: () => import('@/views/oms/salesOrder/index'),
        meta: { title: '售后订单', icon: 'order-setting' }
      },
      //评价管理
      {
        path: 'evaluation',
        name: 'evaluation',
        component: () => import('@/views/oms/evaluation/index'),
        meta: { title: '评价管理', icon: 'order-setting' }
      },
    ]
  },
  //营销商城
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: { title: '营销', icon: 'sms' },
    children: [
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: { title: '广告列表', icon: 'sms-ad' }
      },
      //邀请赚钱
      {
        path: 'invitation',
        name: 'invitation',
        component: () => import('@/views/sms/invitation/index'),
        meta: { title: '邀请赚钱', icon: 'sms-ad' }
      },
      //幸运抽奖
      {
        path: 'luckyDraw',
        name: 'luckyDraw',
        component: () => import('@/views/sms/luckyDraw/index'),
        meta: { title: '幸运抽奖', icon: 'sms-ad' }
      },
      //抽奖记录
      {
        path: 'drawRecord',
        name: 'drawRecord',
        component: () => import('@/views/sms/drawRecord/index'),
        meta: { title: '抽奖记录', icon: 'sms-ad' }
      },
      //积分签到
      {
        path: 'integralSignIn',
        name: 'integralSignIn',
        component: () => import('@/views/sms/integralSignIn/index'),
        meta: { title: '积分签到', icon: 'sms-ad' }
      },
      //签到记录
      {
        path: 'signRecord',
        name: 'signRecord',
        component: () => import('@/views/sms/signRecord/index'),
        meta: { title: '签到记录', icon: 'sms-ad' }
      },
    ]
  },
  //裂变工具
  {
    path: '/fission',
    component: Layout,
    redirect: '/fission/integrationreward',
    name: 'fission',
    meta: { title: '裂变工具', icon: 'sms' },
    children: [
      //奖励积分规则
      {
        path: 'integrationreward',
        name: 'integrationreward',
        component: () => import('@/views/fission/integrationreward/index'),
        meta: { title: '奖励积分', icon: 'sms-ad' }
      },
      //奖励积分规则2
      {
        path: 'reward',
        name: 'reward',
        component: () => import('@/views/fission/reward/index'),
        meta: { title: '奖励积分2', icon: 'sms-ad' }
      },
      //裂变用户及提成比例设置
      {
        path: 'set',
        name: 'set',
        component: () => import('@/views/fission/set/index'),
        meta: { title: '裂变设置', icon: 'sms-ad' }
      },
      {
        path: 'push',
        name: 'push',
        component: () => import('@/views/fission/push/index'),
        meta: { title: '推送工具', icon: 'sms-ad' }
      }
    ]
  },
  //二期数据统计
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/financeReport',
    name: 'statistics',
    meta: { title: '数据统计', icon: 'order' },
    children: [
      //反馈列表
      {
        path: 'inviteUsers',
        name: 'inviteUsers',
        component: () => import('@/views/statistics/inviteUsers/index'),
        meta: { title: '邀请用户统计', icon: 'product-list' }
      },
      // financeReport 财务报表
      {
        path: 'financeReport',
        name: 'financeReport',
        component: () => import('@/views/statistics/financeReport/index'),
        meta: { title: '财务报表', icon: 'product-list' }
      },
      // 产品订单列表
      {
        path: 'productOrderList',
        name: 'productOrderList',
        component: () => import('@/views/statistics/productOrderList/index'),
        meta: { title: '产品订单列表', icon: 'product-list' }
      },
      // 会员订单列表
      {
        path: 'memberOrderList',
        name: 'memberOrderList',
        component: () => import('@/views/statistics/memberOrderList/index'),
        meta: { title: '会员订单列表', icon: 'product-list' }
      },
      // salesmanReport 业务人员对账报表
      {
        path: 'salesmanReport',
        name: 'salesmanReport',
        component: () => import('@/views/statistics/salesmanReport/index'),
        meta: { title: '业务对账报表', icon: 'product-list' }
      },
      // analysisReport  分析报表 =====> 关联用户报表
      {
        path: 'analysisReport',
        name: 'analysisReport',
        component: () => import('@/views/statistics/analysisReport/index'),
        meta: { title: '关联用户报表', icon: 'product-list' }
      },
      // individualQueryReport  个别查询报表
      {
        path: 'individualQueryReport',
        name: 'individualQueryReport',
        component: () => import('@/views/statistics/individualQueryReport/index'),
        meta: { title: '个别查询报表', icon: 'product-list' }
      },
      // 代理商对账表
      {
        path: 'agentstatement',
        name: 'agentstatement',
        component: () => import('@/views/statistics/agentstatement/index'),
        meta: { title: '代理商对账表', icon: 'product-list' }
      },
      // 代理商和分销商邀请表
      {
        path: 'Invitation',
        name: 'Invitation',
        component: () => import('@/views/statistics/Invitation/index'),
        meta: { title: '邀请表', icon: 'product-list' }
      },
      // 分销商
      {
        path: 'distributor',
        name: 'distributor',
        component: () => import('@/views/statistics/distributor/index'),
        meta: { title: '分销商对账表', icon: 'product-list' }
      },
      // 阶梯式
      {
        path: 'steppedRoyalty',
        name: 'steppedRoyalty',
        component: () => import('@/views/statistics/steppedRoyalty/index'),
        meta: { title: '阶梯式数据表', icon: 'product-list' }
      },
      {
        path: 'steppedRatio',
        name: 'steppedRatio',
        component: () => import('@/views/statistics/steppedRatio/index'),
        meta: { title: '阶梯式提成比例', icon: 'product-list' }
      },
      {
        path: 'saleReport',
        name: 'saleReport',
        component: () => import('@/views/statistics/saleReport/index'),
        meta: { title: '阶梯式提成比例', icon: 'product-list' }
      }
    ]
  },
  // {
  //   path: '/fission',
  //   component: Layout,
  //   redirect: '/agent/expertsList',
  //   name: 'fission',
  //   meta: {title: '专家代理', icon: 'order'},
  //   children: [
  //     //提成设置
  //     {
  //       path: 'commissionSet',
  //       name: 'commissionSet',
  //       component: () => import('@/views/fission/integrationreward/index'),
  //       meta: {title: '积分奖励', icon: 'product-list'}
  //     },
  //   ]
  // },
  //店铺管理
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/ums/banner/index'),
        meta: { title: 'banner管理', icon: 'product-list' }
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      },
      {
        path: 'popupList',
        name: 'popupList',
        component: () => import('@/views/ums/pp/index'),
        meta: { title: '弹窗设置', icon: 'sms' }
      }
    ]
  },
  {
    path: '/ads',
    component: Layout,
    redirect: '/ads/dict',
    name: 'ads',
    meta: { title: '字典', icon: 'order' },
    children: [
      {
        path: 'dict',
        name: 'dict',
        component: () => import('@/views/ads/dict/index'),
        meta: { title: '订单列表', icon: 'product-list' }
      }
    ]
  },

  //会员管理
  {
    path: '/memberManagement',
    component: Layout,
    redirect: '/memberManagement/membersKill',
    name: 'memberManagement',
    meta: { title: '会员管理', icon: 'order' },
    children: [
      //会员秒杀
      {
        path: 'membersKill',
        name: 'membersKill',
        component: () => import('@/views/memberManagement/membersKill/index'),
        meta: { title: '会员秒杀', icon: 'product-list' }
      },
      //会员特权
      {
        path: 'memberPrivileges',
        name: 'memberPrivileges',
        component: () => import('@/views/memberManagement/memberPrivileges/index'),
        meta: { title: '会员特权', icon: 'product-list' }
      },
      //会员等级
      {
        path: 'memberGrade',
        name: 'memberGrade',
        component: () => import('@/views/memberManagement/memberGrade/index'),
        meta: { title: '会员等级', icon: 'product-list' }
      },
      //会员列表
      {
        path: 'memberList',
        name: 'memberList',
        component: () => import('@/views/memberManagement/memberList/index'),
        meta: { title: '会员列表', icon: 'product-list' }
      },
      //所有会员
      {
        path: 'allUser',
        name: 'allUser',
        component: () => import('@/views/memberManagement/allUser/index'),
        meta: { title: '所有会员', icon: 'product-list' }
      },
      //购买记录
      {
        path: 'memberPaylist',
        name: 'memberPaylist',
        component: () => import('@/views/memberManagement/memberPaylist/index'),
        meta: { title: '购买记录', icon: 'product-list' }
      },
      //饲料额度比例
      {
        path: 'feedRate',
        name: 'feedRate',
        component: () => import('@/views/memberManagement/feedRate/index'),
        meta: { title: '饲料额度比例', icon: 'product-list' }
      },
      //会员额度预警提醒
      {
        path: 'memberShip',
        name: 'memberShip',
        component: () => import('@/views/memberManagement/memberShip/index'),
        meta: { title: '会员额度预警提醒', icon: 'product-list' }
      }
    ]
  },
  //常见问题
  //会员管理
  {
    path: '/commonProblem',
    component: Layout,
    redirect: '/commonProblem/commonProblem',
    name: 'commonProblem',
    meta: { title: '常见问题', icon: 'order' },
    children: [
      //会员秒杀
      {
        path: 'commonProblem',
        name: 'commonProblem',
        component: () => import('@/views/commonProblem/commonProblem/index'),
        meta: { title: '常见问题', icon: 'product-list' }
      },
    ]
  },
  //专家代理

  {
    path: '/agent',
    component: Layout,
    redirect: '/agent/expertsList',
    name: 'agent',
    meta: { title: '专家代理', icon: 'order' },
    children: [
      //专家列表
      {
        path: 'expertsList',
        name: 'expertsList',
        component: () => import('@/views/agent/expertsList/index'),
        meta: { title: '专家列表', icon: 'product-list' }
      },
      //提成设置
      {
        path: 'commissionSet',
        name: 'commissionSet',
        component: () => import('@/views/agent/commissionSet/index'),
        meta: { title: '提成设置', icon: 'product-list' }
      },
      //代理商列表
      {
        path: 'listAgents',
        name: 'listAgents',
        component: () => import('@/views/agent/listAgents/index'),
        meta: { title: '代理商列表', icon: 'product-list' }
      },
      //代理商审核
      {
        path: 'audit',
        name: 'audit',
        component: () => import('@/views/agent/audit/index'),
        meta: { title: '代理商审核', icon: 'product-list' }
      },
      //专家审核
      {
        path: 'expertReview',
        name: 'expertReview',
        component: () => import('@/views/agent/expertReview/index'),
        meta: { title: '专家审核', icon: 'product-list' }
      },
      //疾病分类
      {
        path: 'classificationDiseases',
        name: 'classificationDiseases',
        component: () => import('@/views/agent/classificationDiseases/index'),
        meta: { title: '疾病分类', icon: 'product-list' }
      },
      {
        path: 'distribution',
        name: 'distribution',
        component: () => import('@/views/agent/distribution/index'),
        meta: { title: '分销用户列表', icon: 'product-list' }
      },
      {
        path: 'deductrate',
        name: 'deductrate',
        component: () => import('@/views/agent/newdeductrate/deductrate'),
        meta: { title: '代理商提成设置', icon: 'product-list' }
      },

      // //分销用户list
      // {
      //   path: 'distribution',
      //   name: 'distribution',
      //   component: () => import('@/views/agent/distribution/index'),
      //   meta: {title: '分销用户列表', icon: 'product-list'}
      // },
    ]
  },
  //积分商城
  {
    path: '/lntegralMall',
    component: Layout,
    redirect: '/lntegralMall/lntegralRecord',
    name: 'lntegralMall',
    meta: { title: '积分商城', icon: 'order' },
    children: [
      //积分记录
      {
        path: 'lntegralRecord',
        name: 'lntegralRecord',
        component: () => import('@/views/lntegralMall/lntegralRecord/index'),
        meta: { title: '积分记录', icon: 'product-list' }
      },
      //现金兑换
      {
        path: 'cashConversion',
        name: 'cashConversion',
        component: () => import('@/views/lntegralMall/cashConversion/index'),
        meta: { title: '现金兑换', icon: 'product-list' }
      },
      //商品列表
      {
        path: 'commodity',
        name: 'commodity',
        component: () => import('@/views/lntegralMall/commodity/index'),
        meta: { title: '商品列表', icon: 'product-list' }
      }
    ]
  },
  //财务管理
  {
    path: '/financial',
    component: Layout,
    redirect: '/financial/mOrderDetails',
    name: 'financial',
    meta: { title: '积分商城', icon: 'order' },
    children: [
      //月订单明细
      {
        path: 'mOrderDetails',
        name: 'mOrderDetails',
        component: () => import('@/views/financial/mOrderDetails/index'),
        meta: { title: '月订单明细', icon: 'product-list' }
      },
      //提现管理
      {
        path: 'cashManage',
        name: 'cashManage',
        component: () => import('@/views/financial/cashManage/index'),
        meta: { title: '提现管理', icon: 'product-list' }
      },
      //代理商对账
      {
        path: 'agentReconciliation',
        name: 'agentReconciliation',
        component: () => import('@/views/financial/agentReconciliation/index'),
        meta: { title: '代理商对账', icon: 'product-list' }
      },
      //专家对账
      {
        path: 'reconciliation',
        name: 'reconciliation',
        component: () => import('@/views/financial/reconciliation/index'),
        meta: { title: '专家对账', icon: 'product-list' }
      }
    ]
  },
  //资讯管理
  {
    path: '/Information',
    component: Layout,
    redirect: '/Information/articleLists',
    name: 'Information',
    meta: { title: '资讯管理', icon: 'order' },
    children: [
      //留言管理
      {
        path: 'leaveMessage',
        name: 'leaveMessage',
        component: () => import('@/views/Information/leaveMessage/index'),
        meta: { title: '留言管理', icon: 'product-list' }
      },
      // //文章分类
      {
        path: 'articleClassification',
        name: 'articleClassification',
        component: () => import('@/views/Information/articleClassification/index'),
        meta: { title: '文章分类', icon: 'product-list' }
      },
      // //文章列表
      {
        path: 'articleLists',
        name: 'articleLists',
        component: () => import('@/views/Information/articleLists/index'),
        meta: { title: '文章列表', icon: 'product-list' }
      },
      // //公司简介
      {
        path: 'companyProfile',
        name: 'companyProfile',
        component: () => import('@/views/Information/companyProfile/index'),
        meta: { title: '公司简介', icon: 'product-list' }
      },

    ]
  },
  //优惠券
  {
    path: '/coupons',
    component: Layout,
    redirect: '/coupons/couponsList',
    name: 'coupons',
    meta: { title: '优惠券', icon: 'order' },
    children: [
      //优惠券列表
      {
        path: 'couponsList',
        name: 'couponsList',
        component: () => import('@/views/coupons/couponsList/index'),
        meta: { title: '优惠券列表', icon: 'product-list' }
      },
      //领取列表

      {
        path: 'couponCollectionList',
        name: 'couponCollectionList',
        component: () => import('@/views/coupons/couponCollectionList/index'),
        meta: { title: '优惠券领取列表', icon: 'product-list' }
      }
    ]
  },
  // //专家问诊
  {
    path: '/expertInterrogation',
    component: Layout,
    redirect: '/expertInterrogation/expertInterrList',
    name: 'expertInterrogation',
    meta: { title: '专家', icon: 'order' },
    children: [
      {
        path: 'expertInterrList',
        name: 'expertInterrList',
        component: () => import('@/views/expertInterrogation/expertInterrList/index'),
        meta: { title: '专家问诊', icon: 'product-list' }
      }
    ]
  },
  //直播
  {
    path: '/live',
    component: Layout,
    redirect: '/live/liveList',
    name: 'live',
    meta: { title: '直播', icon: 'order' },
    children: [
      //直播列表
      {
        path: 'liveList',
        name: 'liveList',
        component: () => import('@/views/live/liveList/index'),
        meta: { title: '直播列表', icon: 'product-list' }
      }
    ]
  },
  //客服
  {
    path: '/customer',
    component: Layout,
    redirect: '/customer/customerList',
    name: 'customer',
    meta: { title: '客服', icon: 'order' },
    children: [
      //直播列表
      {
        path: 'customerList',
        name: 'customerList',
        component: () => import('@/views/customer/customerList/index'),
        meta: { title: '客服服务', icon: 'product-list' }
      }
    ]
  },
  //反馈
  {
    path: '/feedback',
    component: Layout,
    redirect: '/feedback/feedbackList',
    name: 'feedback',
    meta: { title: '直播', icon: 'order' },
    children: [
      //反馈列表
      {
        path: 'feedbackList',
        name: 'feedbackList',
        component: () => import('@/views/feedback/feedbackList/index'),
        meta: { title: '反馈列表', icon: 'product-list' }
      }
    ]
  },
  //用户行为
  {
    path: '/memberBehavior',
    component: Layout,
    redirect: '/memberBehavior/memberBehaviorList',
    name: 'memberBehavior',
    meta: { title: '用户行为', icon: 'order' },
    children: [
      //用户行为列表
      {
        path: 'memberBehaviorList',
        name: 'memberBehaviorList',
        component: () => import('@/views/memberBehavior/memberBehaviorList/index'),
        meta: { title: '用户行为', icon: 'sms' }
      }

    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js